import { Api } from '@axiom/ui';
import type { TopTask } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type readTopTaskResponseType = {
  data: TopTask[];
};

class TopTasksApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readTopTasks() {
    return super.read<readTopTaskResponseType>({
      endpoint: `/topTasks`,
      method: 'GET',
    });
  }

  async createTopTaskSnooze(topTaskId: TopTask['id']) {
    return super.write<readTopTaskResponseType>({
      endpoint: `/topTasks/${topTaskId}/snooze`,
      method: 'POST',
    });
  }

  async refreshTopTasks() {
    return super.invalidate(`/topTasks`);
  }
}

export const TopTasksApi = new TopTasksApiClass();
